// assets
import { IconCode, IconKey, IconWebhook, IconGitBranch, IconShield } from '@tabler/icons-react';

// constant
const icons = {
    IconCode,
    IconKey,
    IconWebhook,
    IconGitBranch,
    IconShield
};

// ==============================|| API GATEWAY (theo project từ Workspace) ||============================== //

const apiGateway = {
    id: 'api-gateway',
    title: 'API Gateway',
    type: 'group',
    children: [
        {
            id: 'api-gateway-module',
            title: 'API Gateway',
            type: 'collapse',
            icon: icons.IconCode,
            children: [
                {
                    id: 'api-gateway-dashboard',
                    title: 'Dashboard',
                    type: 'item',
                    url: '/api-gateway/dashboard',
                    breadcrumbs: false
                },
                {
                    id: 'api-keys-management',
                    title: 'API Keys',
                    type: 'item',
                    url: '/api-gateway/api-keys',
                    breadcrumbs: false
                },
                {
                    id: 'webhooks-management',
                    title: 'Webhooks',
                    type: 'item',
                    url: '/api-gateway/webhooks',
                    breadcrumbs: false
                },
                {
                    id: 'rate-limiting',
                    title: 'Rate Limiting',
                    type: 'item',
                    url: '/api-gateway/rate-limiting',
                    breadcrumbs: false
                },
                {
                    id: 'api-keys-usage',
                    title: 'Usage Analytics',
                    type: 'item',
                    url: '/api-gateway/usage',
                    breadcrumbs: false
                },
                {
                    id: 'monitoring',
                    title: 'Monitoring',
                    type: 'item',
                    url: '/api-gateway/monitoring',
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export default apiGateway;
